import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Badge, Button, Form, InputGroup, Pagination } from 'react-bootstrap';
import { BsExclamationTriangleFill, BsClockFill, BsCheckCircleFill, BsXCircleFill, BsSearch, BsDownload, BsArrowRepeat, BsEyeFill, BsCheckLg, BsXLg, BsArrowUpShort, BsArrowDownShort } from 'react-icons/bs';
import "../../complainreport.css";

import { useNavigate, Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const COMPLAINTS = [
    {
        id: 'CR-1041',
        complainant: 'Anitha R.',
        cId: '#10482',
        cAv: 'AR',
        cAvc: 'av-rose',
        reported: 'Suresh K.',
        rId: '#10319',
        rAv: 'SK',
        rAvc: 'av-amber',
        category: 'Fake Profile',
        date: 'Apr 08, 2026',
        status: 'Pending'
    },
    {
        id: 'CR-1040',
        complainant: 'Priya M.',
        cId: '#10451',
        cAv: 'PM',
        cAvc: 'av-teal',
        reported: 'Ravi V.',
        rId: '#10290',
        rAv: 'RV',
        rAvc: 'av-purple',
        category: 'Harassment',
        date: 'Apr 07, 2026',
        status: 'Under Review'
    },
    {
        id: 'CR-1039',
        complainant: 'Kavitha N.',
        cId: '#10388',
        cAv: 'KN',
        cAvc: 'av-amber',
        reported: 'Mohan G.',
        rId: '#10201',
        rAv: 'MG',
        rAvc: 'av-red',
        category: 'Fraud',
        date: 'Apr 06, 2026',
        status: 'Resolved'
    },
    {
        id: 'CR-1038',
        complainant: 'Sowmya L.',
        cId: '#10422',
        cAv: 'SL',
        cAvc: 'av-rose',
        reported: 'Jagadish P.',
        rId: '#10175',
        rAv: 'JP',
        rAvc: 'av-teal',
        category: 'Spam',
        date: 'Apr 05, 2026',
        status: 'Rejected'
    },
    {
        id: 'CR-1037',
        complainant: 'Deepa R.',
        cId: '#10499',
        cAv: 'DR',
        cAvc: 'av-purple',
        reported: 'Venkat K.',
        rId: '#10340',
        rAv: 'VK',
        rAvc: 'av-amber',
        category: 'Fake Profile',
        date: 'Apr 04, 2026',
        status: 'Pending'
    },
    {
        id: 'CR-1036',
        complainant: 'Meena S.',
        cId: '#10371',
        cAv: 'MS', cAvc: 'av-teal',
        reported: 'Arun T.',
        rId: '#10288',
        rAv: 'AT',
        rAvc: 'av-rose',
        category: 'Harassment',
        date: 'Apr 03, 2026',
        status: 'Resolved'
    },
    {
        id: 'CR-1035',
        complainant: 'Lakshmi B.',
        cId: '#10354',
        cAv: 'LB',
        cAvc: 'av-red',
        reported: 'Karthik M.',
        rId: '#10260',
        rAv: 'KM',
        rAvc: 'av-purple',
        category: 'Fraud',
        date: 'Apr 02, 2026',
        status: 'Under Review'
    },
];

const STATUS_META = {
    'Pending': { cls: 'badge-pending', label: 'Pending' },
    'Resolved': { cls: 'badge-resolved', label: 'Resolved' },
    'Rejected': { cls: 'badge-rejected', label: 'Rejected' },
    'Under Review': { cls: 'badge-review', label: 'Under Review' },
};



const STAT_CARDS = [
    { key: 'total', label: 'Total Complaints', value: 248, change: '+12% this month', up: true, icon: <BsExclamationTriangleFill />, accentCls: 'accent-crimson' },
    { key: 'pending', label: 'Pending', value: 64, change: '8 new today', up: false, icon: <BsClockFill />, accentCls: 'accent-amber' },
    { key: 'resolved', label: 'Resolved', value: 157, change: '93% success', up: true, icon: <BsCheckCircleFill />, accentCls: 'accent-green' },
    { key: 'rejected', label: 'Rejected', value: 27, change: '3 this week', up: false, icon: <BsXCircleFill />, accentCls: 'accent-red' },
];

export default function ComplainReport() {



    const [search, setSearch] = useState('');
    const [statusF, setStatusF] = useState('All');
    const [categoryF, setCategoryF] = useState('All');
    const [activePage, setActivePage] = useState(1);

    const itemsPerPage = 4;



    const navigate = useNavigate();


    const filtered = COMPLAINTS.filter(c => {
        const matchS = statusF === 'All' || c.status === statusF;
        const matchC = categoryF === 'All' || c.category === categoryF;
        const q = search.toLowerCase();
        const matchQ = !q || c.complainant.toLowerCase().includes(q) || c.id.toLowerCase().includes(q) || c.category.toLowerCase().includes(q);
        return matchS && matchC && matchQ;
    });

    const totalPages = Math.ceil(filtered.length / itemsPerPage);

    const startIndex = (activePage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const paginatedData = filtered.slice(startIndex, endIndex);


    useEffect(() => {
        setActivePage(1);
    }, [search, statusF, categoryF]);

    return (
        <>

            <div className="breadcrumb-bar mb-4">
                <div className="breadcrumb-left">
                    <Link to="/admin/home" className="breadcrumb-link active">
                        Home
                    </Link>

                    <span className="breadcrumb-separator">
                        {" "}
                        <IoIosArrowForward size={15} />{" "}
                    </span>

                    <span
                        className="breadcrumb-link inactive"
                        onClick={() => navigate("/admin/complainreport")}
                    >
                        Complain report
                    </span>
                </div>

                {/* <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/candidate")}
        >
          Candidate 
        </button> */}
            </div>

            <div className="cr-page">


                <Container fluid className="cr-content py-4 px-3 px-md-4">

                    <div className="cr-topbar d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 px-md-4 py-3 my-4 rounded-3">
                        <div className="d-flex align-items-center gap-3">
                            <div className="cr-topbar-icon d-flex align-items-center justify-content-center">
                                <BsExclamationTriangleFill size={18} color="#fff" />
                            </div>
                            <div>
                                <div className="cr-topbar-title">Complain Report</div>
                                <div className="cr-topbar-sub">KVL Matrimony Admin Dashboard</div>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {/* <Button className="cr-tb-btn" size="sm">
                                <BsDownload size={13} /> <span className="d-none d-sm-inline ms-1">Export</span>
                            </Button> */}
                            <Button className="cr-tb-btn" size="sm">
                                <BsArrowRepeat size={13} /> <span className="d-none d-sm-inline ms-1">Refresh</span>
                            </Button>
                        </div>
                    </div>

                    {/* ── Stat Cards ── */}
                    <Row className="g-3 mb-4">
                        {STAT_CARDS.map(s => (
                            <Col xs={6} xl={3} key={s.key}>
                                <Card className={`cr-stat-card h-100 ${s.accentCls}`}>
                                    <Card.Body className="p-3">
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div>
                                                <div className="cr-stat-num">{s.value}</div>
                                                <div className="cr-stat-label">{s.label}</div>
                                                <div className={`cr-stat-change mt-2 d-flex align-items-center gap-1 ${s.up ? 'change-up' : 'change-down'}`}>
                                                    {s.up ? <BsArrowUpShort size={14} /> : <BsArrowDownShort size={14} />}
                                                    {s.change}
                                                </div>
                                            </div>
                                            <div className={`cr-stat-icon-wrap icon-${s.key}`}>
                                                {s.icon}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <Row>
                        <Col className='my-4'>
                            {/* Filter Bar */}
                            <div className="cr-filter-bar d-flex flex-wrap gap-2 px-3 py-3">
                                <InputGroup className="cr-search-group">
                                    <InputGroup.Text className="cr-search-icon">
                                        <BsSearch size={13} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        className="cr-search-input"
                                        placeholder="Search name, ID or complaint…"
                                        value={search}
                                        onChange={e => setSearch(e.target.value)}
                                    />
                                </InputGroup>

                                <Form.Select
                                    className="cr-filter-select"
                                    value={statusF}
                                    onChange={e => setStatusF(e.target.value)}
                                >
                                    <option value="All">All Status</option>
                                    <option>Pending</option>
                                    <option>Resolved</option>
                                    <option>Rejected</option>
                                    <option>Under Review</option>
                                </Form.Select>

                                <Form.Select
                                    className="cr-filter-select"
                                    value={categoryF}
                                    onChange={e => setCategoryF(e.target.value)}
                                >
                                    <option value="All">All Categories</option>
                                    <option>Fake Profile</option>
                                    <option>Harassment</option>
                                    <option>Fraud</option>
                                    <option>Spam</option>
                                </Form.Select>

                                <Form.Select className="cr-filter-select">
                                    <option>This Month</option>
                                    <option>Last 7 Days</option>
                                    <option>Last 30 Days</option>
                                </Form.Select>

                                <Button className="cr-export-btn ms-auto d-flex align-items-center gap-2">
                                    <BsDownload size={13} /> Export CSV
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    
                    <Card className="customtable-card mt-3">

                       
                        <Card.Header className="cr-panel-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <div>
                                <div className="cr-panel-title">Complaint Records</div>
                                <div className="cr-panel-sub">All user-submitted complaints — manage and take action</div>
                            </div>
                            <Badge className="cr-total-badge">{filtered.length} records</Badge>
                        </Card.Header>

                        {/* Table */}
                        <div className="table-responsive">
                            <Table className="custom-table align-middle">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Complainant</th>
                                        <th>Reported User</th>
                                        <th className="d-none d-md-table-cell">Category</th>
                                        <th className="d-none d-lg-table-cell">Date</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.length === 0 ? (
                                        <tr>
                                            <td colSpan={7} className="text-center py-5 cr-empty">
                                                No complaints match your filters.
                                            </td>
                                        </tr>
                                    ) : paginatedData.map(c => {

                                        const meta = STATUS_META[c.status];


                                        return (
                                            <tr key={c.id}>

                                                <td className="index">{c.id}</td>

                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className={`cr-avatar ${c.cAvc}`}>{c.cAv}</div>
                                                        <div>
                                                            <div className="plan-nm">{c.complainant}</div>
                                                            <div className="cr-uid">{c.cId}</div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className={`cr-avatar ${c.rAvc}`}>{c.rAv}</div>
                                                        <div>
                                                            <div className="plan-nm">{c.reported}</div>
                                                            <div className="cr-uid">{c.rId}</div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="d-none d-md-table-cell">
                                                    <span className="cr-cat-pill">{c.category}</span>
                                                </td>

                                                <td className="d-none d-lg-table-cell">{c.date}</td>

                                                <td>
                                                    <span className={`cr-badge ${meta?.cls}`}>
                                                        <span className="cr-dot"></span>
                                                        {meta?.label}
                                                    </span>
                                                </td>

                                                <td>
                                                    <div className="actions">
                                                        <button className="act-btn edit" title="View">
                                                            <BsEyeFill />
                                                        </button>
                                                        {(c.status === 'Pending' || c.status === 'Under Review') && (
                                                            <>
                                                                <button className="act-btn tog" title="Resolve">
                                                                    <BsCheckLg />
                                                                </button>
                                                                <button className="act-btn del" title="Reject">
                                                                    <BsXLg />
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>

                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>

                        {/* Pagination */}
                        <div className="pagination-wrap mx-3">
                            <div>
                                Showing {startIndex + 1} –{' '}
                                {Math.min(startIndex + itemsPerPage, filtered.length)} of{' '}
                                {filtered.length}
                            </div>

                            <Pagination className="custom-pagination">
                                <Pagination.Prev
                                    onClick={() => setActivePage(p => Math.max(1, p - 1))}
                                    disabled={activePage === 1}
                                />
                                {[...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item
                                        key={i}
                                        active={i + 1 === activePage}
                                        onClick={() => setActivePage(i + 1)}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next
                                    onClick={() => setActivePage(p => Math.min(totalPages, p + 1))}
                                    disabled={activePage === totalPages}
                                />
                            </Pagination>
                        </div>

                    </Card>

                </Container>
            </div>
        </>
    );
};
